import queryString from "query-string";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth, useLanguage } from "../../../hooks/hooks";
import { Language } from "../../../types/language";

export function SignInFromKPass() {
  const { accessToken, refreshToken } = queryString.parse(window.location.search);
  const navigate = useNavigate();
  const { onLoggedIn } = useAuth();
  const { setLang } = useLanguage();

  useEffect(() => {
    if (typeof accessToken != "string" || typeof refreshToken != "string") {
      navigate("/");
    } else {
      setLang(Language.KO);
      onLoggedIn(accessToken, refreshToken);
      navigate("/purchase-voucher");
    }
  }, [accessToken, refreshToken, navigate, onLoggedIn, setLang]);

  return <></>;
}
